import React from 'react';
import WName, {WArticle} from '../WName';
import Eon from '../Eon';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual,
  the_key_is_imagination,
  Rando, SillyName
} from '../common';

// Self = BODY, no do'oh d'oh???//
export const seb_ion = {
  name: "seb ion",
  alternatives: "seb,you are your body",
  prelude:<span>
    <NW>SEB</NW>: ‘self’ = (equals) body. <NW>ION</NW> = <PL>imposition</PL> of <AL name="story">narrative</AL>.
  </span>,
  header: <span>
    ‘Self’ = BODY, no d’oh d’oh?.
  </span>,
  outside: <span>
    The ‘SEB ION’ is the <PL>human-standard</PL> ‘self’ = body imposition of narrative. <i><AL name="notnew.p.arendt">Without</AL> <QL name="salvation">questions</QL></i>, <AL name="notnew.">Socrates</AL> might note.
  </span>,
  preview: <div className="problem-preview">
    <p>The SEB ION in practice:</p>
    <ul>
      <li>You (<PL>metaphysically</PL>) <i>are</i> your <NW>khet</NW>: your <AL name="handicap">physical</AL>, <LRL name="reactivity">reacto-biological</LRL> (<OML name="aliens">probably</OML>-<QL>human</QL>) <i>body</i>.</li>
      <li>You (<PL name="special">specifically</PL> and ‘<PL name="individuality">personally</PL>’ are put here <i><QL name="imperative">for a reason</QL></i>, but it is <AL name="Hell">not YOURS to know</AL> why. (There is a ‘reason’, but <i><PL name="ignorabimus">you will never know</PL></i>.)</li>
      <li>Maybe you did something <QL name="TM">Bad<sup>®</sup></QL> in a PastLife<sup>™</sup>; <PL>Mamma</PL> (assuminig, for whatever reason, a <i><PL>female</PL></i> <NW>GodEE</NW>) has given you this Life<sup>®</sup> <i><PL name="transactionality">transactionally</PL></i> as Punishment<sup>®</sup> or Reward<sup>®</sup>.</li>
      <li>When you (‘as’ <NW>khet</NW>; <i>you are your body</i>) <i><QL name="life.death">die</QL></i>, <AL>YOU</AL><sup>™</sup> will survive in the external <OML name="stories.">Heaven</OML> <LRL name="nepantla.error"><i>outside</i> the set of everything</LRL>.</li>
      <li>According to <LRL name="game">SOME</LRL> <AL name="religion">religious ‘traditions’</AL> (cf. <NW>conservative thinking</NW>)
As YOURSELF<sup>™</sup>; your Self<sup>™</sup> is <QL name="silly.110">110%</QL> going to <OML name="offensive">persistsist foreverever</OML></li>
      <li>(etc., etc.)</li>
    </ul>
  </div>,
  text: <div className="problem-text">
[under construction]
  </div>,
};
